import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';

@Component({
  selector: 'app-scad-drag-drop-body',
  templateUrl: './scad-drag-drop-body.component.html',
  styleUrls: ['./scad-drag-drop-body.component.scss']
})
export class ScadDragDropBodyComponent {

  @ViewChild('drawflow') drawflowList!: ElementRef;

  constructor(
    private _renderer2: Renderer2,
    public _flowBuilder: FlowBuilderService,
    private _router: Router
  ) {
    this._flowBuilder.renderer2 = this._renderer2;
  }


  ngOnInit(): void {}


  ngAfterViewInit(): void {
    this._flowBuilder.drawFlowHtmlElement = <HTMLElement>document.getElementById('drawflow');
    this._flowBuilder.drawflowList = this.drawflowList;
    this._flowBuilder.initDrawFlow(this._flowBuilder?.drawFlowHtmlElement);
  }



}
